window.theme = window.theme || {};

window.theme.sizes = {
  mobile: 480,
  small: 750,
  large: 990,
  widescreen: 1400,
};

window.theme.keyboardKeys = {
  TAB: 'Tab',
  ENTER: 'Enter',
  NUMPADENTER: 'NumpadEnter',
  ESCAPE: 'Escape',
  SPACE: 'Space',
  LEFTARROW: 'ArrowLeft',
  RIGHTARROW: 'ArrowRight',
};

window.theme.focusable = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
